import useAccount from "./useAccount";

export function useChinaUser() {
  const { data: accountData, isPending: isAccountPending } = useAccount();

  const isLoading = isAccountPending || accountData === undefined;
  const isChinaUser = accountData?.countryCode === "CN";

  return {
    isChinaUser: isLoading ? undefined : isChinaUser,
    isLoading,
  };
}
